import { Link } from "react-router-dom";
import { todayContentItems } from "@/mocks/home";

export default function TodayContent() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6 mb-12 md:mb-16">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-50 leading-tight lg:max-w-md">
            今日吃瓜
            <br />
            内容区
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-md leading-relaxed">
            每天更新最新爆料内容，全方位追踪网红塌房事件。吃瓜就要趁热，别让你的八卦雷达落后于人。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          {todayContentItems.map((item) => {
            if (item.featured) {
              return (
                <Link
                  key={item.id}
                  to={`/article/${item.articleId}`}
                  className="group lg:col-span-1 lg:row-span-2 bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.01]"
                >
                  <div className="aspect-[16/10] w-full">
                    <img
                      src={item.imageUrl}
                      alt={item.title}
                      title={item.title}
                      className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-5 md:p-6">
                    <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-50 mb-3 leading-snug">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      {item.summary}
                    </p>
                  </div>
                </Link>
              );
            }

            return (
              <Link
                key={item.id}
                to={`/article/${item.articleId}`}
                className="group bg-background-200/50 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.01]"
              >
                <div className="aspect-[4/3] w-full relative">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    title={item.title}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  {item.tag && (
                    <span className="absolute top-3 left-3 whitespace-nowrap px-2.5 py-1 text-xs font-semibold bg-accent-500 text-background-950 rounded-full flex items-center gap-1">
                      <i className="ri-fire-line text-xs"></i>
                      {item.tag}
                    </span>
                  )}
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-base md:text-lg font-heading font-bold text-foreground-100 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-600">{item.description}</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}